module.exports = {"translations":{"step-price-loader-advantage-program-cu":"Overfører medlemsinfo $[organizationName] til prisberegner","step-confirmation-full-purchase-list2":""}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/packages/cat/cu/package.cat-tjm-text.json
// module id = 725
// module chunks = 0